import * as yup from 'yup';

const groupFormSchema = yup.object().shape({
  name: yup
    .string().trim().required('accessGroupsNameRequired'),
});

export default groupFormSchema;
